import DEBUG from '/js/common/debug';
import log from '/js/common/Logger';
import prebid_options from './hb_default_options';
import * as prebid_code from './prebid2.13.0.js';
import _ from 'lodash';
import {E_BIDS_READY} from './hb_events';

const PREBID_TIMEOUT = 1500;
const INIT_FAILSAFE_TIMEOUT = 3500;
const POMAD_FAILSAFE_TIMEOUT = 5000;

// function nop(prebid_code) {}
// nop(prebid_code);

//create namespace for our fallback
window.pomad = {};
window.pomad.hb = {};
window.pomad.hb.refreshBid = function(dfpSlot, slotHbConfig = null) {
  window.pomad.hb.refreshBids([dfpSlot], [slotHbConfig]);
};

window.pomad.hb.refreshBids = function(slots, slotsConfigs = []) {
  if (!window.pomad.hb._instance.isInit) window.pomad.hb._instance.init();
  log.always('refreshing bids for ', _.map(slots, slot => slot.getAdUnitPath()));
  const newAdUnits = [];
  googletag.cmd.push(() => {
    slots = _.isUndefined(slots) ? googletag.pubads().getSlots() : slots;
    _.forEach(slots, (slot, idx) => {
      const unitName = window.pomad.hb.placements[slot.getSlotElementId()];
      if (_.isEmpty(unitName)) { //prepare new slot for header bidding from our configuration (if exists)
        let unitConfig = slotsConfigs[idx];
        if (!_.isEmpty(unitConfig)) {
          unitConfig.selector = slot.getSlotElementId();
          let currAdUnitForHb = window.pomad.hb._instance._prepareOneAdUnit(unitConfig);
          window.pomad.hb.placements[currAdUnitForHb.code] = currAdUnitForHb.pmd_name;
          newAdUnits.push(currAdUnitForHb);
        }
      }
    });
    const divIds = _.map(slots, (slot) => slot.getSlotElementId());

    pbjs.que.push(
      function() {
        if (!_.isEmpty(newAdUnits)) {
          pbjs.addAdUnits(newAdUnits);
        }
        pbjs.requestBids({
          timeout: PREBID_TIMEOUT,
          adUnitCodes: divIds,
          bidsBackHandler: function() {
            pbjs.setTargetingForGPTAsync(divIds);
            googletag.pubads().refresh(slots);
          }
        });
        _.forEach(divIds, code => {
          const unitName = window.pomad.hb.placements[code];
          Analytics.sendEvent('HB', 'bids requested', unitName || 'unknown');
        });
      });

  })
};

class HB {

  constructor() {
    window.pomad.hb._instance = this;
  }

  refreshBids = window.pomad.hb.refreshBids;
  refreshBid = window.pomad.hb.refreshBid;

  init() {
    this.isInit = true;
    Analytics.sendEvent('dev', 'initBids');
    // log.always('Initializing pomad bids');
    // if (DEBUG) {
    //     //googletag.cmnod.push(() => {googletag.openConsole() });
    // }
    //const adUnits = this._prepareInitialAdUnits();
    //window.pomad.hb.adUnits = adUnits;
    //if (_.isEmpty(adUnits)) return;
    // this.createWithUnits(adUnits);
  }

  _fire(eventName, data = {}) {
    let event = new Event(eventName);
    Object.assign(event, data);
    if (DEBUG) {
      window.addEventListener(eventName, () => {
        log.debug(`${eventName} fired`);
      });
    }
    window.dispatchEvent(event);
  }

  _fireReadyEvent() {
    log.always(`${E_BIDS_READY} fired`);
    this._fire(E_BIDS_READY);
  }

  prepareAdUnits(dfp_ad_units_with_selectors) {
    return _.filter(_.map(dfp_ad_units_with_selectors, this._prepareOneAdUnit.bind(this)), unit => unit !== null);
  }


  _prepareOneAdUnit(unitConfig) {
    if (_.isEmpty(unitConfig) || _.isEmpty(unitConfig.selector) || _.isEmpty(unitConfig.bidders)) return null;
    const hbAdUnit = {
      pmd_name: unitConfig.name,
      code: unitConfig.selector,
      mediaTypes: {
        banner: {
          sizes: unitConfig.sizes
        }
      },
      bids: this._createBids(unitConfig.bidders),
      is_manually_refreshed: unitConfig.isManuallyRefreshed || false
    };
    return hbAdUnit;
  }

  _createBids(bidders) {
    return _.map(bidders, (params, bidderName) => {
      return {
        bidder: _.head(_.split(bidderName,'__')),
        params: params
      }
    })
  }

  createWithUnits(adUnits) {
    window.pomad.hb.placements = {};
    _.forEach(adUnits, unit => {
      if (!_.isEmpty(window.pomad.hb.placements[unit.code])) {
        log.warn(`overriding placement ${unit.code} => {new_val: ${unit.pmd_name}, old_val: ${window.pomad.hb.placements[unit.code]}`)
      }
      window.pomad.hb.placements[unit.code] = unit.pmd_name;
    });
    const self = this;
    const hbReducedAdUnits = _.map(adUnits, adUnit => _.pick(adUnit, ['bids', 'mediaTypes', 'code']));
    // window.googletag = window.googletag || {};
    // googletag.cmd = googletag.cmd || [];
    // googletag.cmd.push(function() {
    //     googletag.pubads().disableInitialLoad();
    // });
    window.pbjs = pbjs || {};
    pbjs.que = pbjs.que || [];

    //define fallback
    window.pomad.hb.initDFP = function() {
      if (window.pomad.hb.isDfpInit) return;
      window.pomad.hb.isDfpInit = true;

      googletag.cmd.push(function() {
        pbjs.que.push(function() {
          pbjs.setTargetingForGPTAsync && pbjs.setTargetingForGPTAsync();
          self._fireReadyEvent();
          //googletag.pubads().refresh();
        });
      });
    };

    pbjs.que.push(function() {
      if (DEBUG) {
        pbjs.getConfig((config) => log.debug('config set:', config));
        pbjs.onEvent('bidWon', (data) => {
          // const unitName = window.pomad.hb.placements[data.adUnitCode];
          // self.sendBidWonEvent(unitName || 'unknown');
          log.debug('Got wining bid', data.bidderCode+ ' won the ad server auction for ad unit ' +data.adUnitCode+ ' at ' +data.cpm+ ' CPM');
        });
        pbjs.onEvent('bidResponse', (data) => {
          log.debug('Got bid response', data);
        });
        pbjs.onEvent('setTargeting', (data) => {
          log.debug('Setting bid DFP Targeting', data);
        });
        pbjs.onEvent('bidRequested', (data) => {
          log.debug('Requesting bid', data);
        });
        pbjs.onEvent('noBid', (data) => {
          log.debug('noBid', data);
        });
      }
      pbjs.bidderSettings = prebid_options.bidderSettings;
      pbjs.setConfig(prebid_options.config);
      pbjs.addAdUnits(hbReducedAdUnits);
      //filter out all in item units
      const codesForInitialBidding = _.map(_.filter(adUnits, adUnit => !adUnit.is_manually_refreshed), adUnit => adUnit.code);
      pbjs.requestBids({
        bidsBackHandler: window.pomad.hb.initDFP,
        timeout: PREBID_TIMEOUT
      });
      _.forEach(codesForInitialBidding, code => {
        const unitName = window.pomad.hb.placements[code];
        Analytics.sendEvent('HB', 'bids requested', unitName);
      });

    });

    // in case PBJS doesn't load
    setTimeout(function() {
      window.pomad.hb.initDFP();
    }, INIT_FAILSAFE_TIMEOUT);
  }


}

export default HB;
